// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the row */
.row-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0px;
  margin: 0 auto;
  width: 1444px;
  height: 36px;
}

.row-container .form-group {
  margin-bottom: 0;
}

.input-group .btn-light.calendar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
}

input[type="text"].form-control {
  padding: 6px 12px;
}

select.form-control {
  padding: 6px 12px;
}

.modal-divider {
  border: none;
  border-top: 1px solid #e5e5e5;
  margin: 0;
}

.modal-body {
  display: flex;
  align-items: stretch; /* Ensure children stretch to fill container height */
}

.col-md-3 {
  display: flex;
  align-items: stretch;
  position: relative;
  box-sizing: border-box;
  width: 202px;
  height: 500px;
}

.ul-container {
  display: flex;
  flex-direction: column;
  padding: 4px 8px;
  gap: 10px;
  
  width: 170px;
  height: 28px;
  border-radius: 8px;
}

.vertical-line-container {
  display: flex;
  align-items: stretch;
  margin-left: 100px;
}

.vertical-line {
  border: none;
  border-left: 1px solid #e5e5e5;
  height: 100%;
  margin: 0;
}

.nav-item {
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 4px; /* Optional: for better appearance */
}

.nav-item a {
  text-decoration: none;
  display: block;
  width: 100%;
}

.nav-item.active {
  background-color: rgba(55, 137, 112, 0.1);
  font-weight: bold;
}


.dropdown-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  width: 239.5px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
}

.label {
  flex: none;
  order: 0;
  flex-grow: 1;
}

.dropdown {
  flex: none;
  order: 1;
  flex-grow: 1;
  border: none;
  outline: none;
  background: none;
}

.date-input {
  flex: none;
  order: 1;
  flex-grow: 1;
  border: none;
  outline: none;
  background: none;
}

.button-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.button-group {
  display: flex;
  gap: 10px; /* Adjust the gap as needed */
}

.button-group.start {
  justify-content: flex-start;
}

.button-group.end {
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/app/views/compliance-management/eu-data-management/eu-data-management-detail/eu-data-management-detail.component.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAoB,EAAE,qDAAqD;AAC7E;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;;EAET,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;;AAGA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,6BAA6B;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Container for the row */\r\n.row-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  padding: 0px;\r\n  margin: 0 auto;\r\n  width: 1444px;\r\n  height: 36px;\r\n}\r\n\r\n.row-container .form-group {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.input-group .btn-light.calendar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 12px;\r\n}\r\n\r\ninput[type=\"text\"].form-control {\r\n  padding: 6px 12px;\r\n}\r\n\r\nselect.form-control {\r\n  padding: 6px 12px;\r\n}\r\n\r\n.modal-divider {\r\n  border: none;\r\n  border-top: 1px solid #e5e5e5;\r\n  margin: 0;\r\n}\r\n\r\n.modal-body {\r\n  display: flex;\r\n  align-items: stretch; /* Ensure children stretch to fill container height */\r\n}\r\n\r\n.col-md-3 {\r\n  display: flex;\r\n  align-items: stretch;\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  width: 202px;\r\n  height: 500px;\r\n}\r\n\r\n.ul-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 4px 8px;\r\n  gap: 10px;\r\n  \r\n  width: 170px;\r\n  height: 28px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.vertical-line-container {\r\n  display: flex;\r\n  align-items: stretch;\r\n  margin-left: 100px;\r\n}\r\n\r\n.vertical-line {\r\n  border: none;\r\n  border-left: 1px solid #e5e5e5;\r\n  height: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.nav-item {\r\n  padding: 4px 8px;\r\n  cursor: pointer;\r\n  border-radius: 4px; /* Optional: for better appearance */\r\n}\r\n\r\n.nav-item a {\r\n  text-decoration: none;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.nav-item.active {\r\n  background-color: rgba(55, 137, 112, 0.1);\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n.dropdown-container {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  gap: 8px;\r\n  width: 239.5px;\r\n  height: 36px;\r\n  background: #FFFFFF;\r\n  border: 1px solid #D0D5DD;\r\n  border-radius: 8px;\r\n}\r\n\r\n.label {\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 1;\r\n}\r\n\r\n.dropdown {\r\n  flex: none;\r\n  order: 1;\r\n  flex-grow: 1;\r\n  border: none;\r\n  outline: none;\r\n  background: none;\r\n}\r\n\r\n.date-input {\r\n  flex: none;\r\n  order: 1;\r\n  flex-grow: 1;\r\n  border: none;\r\n  outline: none;\r\n  background: none;\r\n}\r\n\r\n.button-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  gap: 10px; /* Adjust the gap as needed */\r\n}\r\n\r\n.button-group.start {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.button-group.end {\r\n  justify-content: flex-end;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
